import { ArrowUpRight } from "lucide-react";
import CardServicos from "./cardServicos";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "./carousel";
import { useState } from "react";

// Custom NumberedCard component for when no icon is provided
const NumberedCard = ({ number, title, text, glowColor = "#A002CB", url }) => {
    const [isHovered, setIsHovered] = useState(false);

    function handleMouseEnter() {
        setIsHovered(true);
    }

    function handleMouseLeave() {
        setIsHovered(false);
    }

    const CardContent = () => (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onTouchStart={handleMouseEnter}
            onTouchEnd={handleMouseLeave}
            className="relative mb-4 md:mb-0 hover:cursor-pointer"
        >
            <div
                className={`absolute inset-0 transition-opacity duration-300 blur-xl ${isHovered ? "opacity-80" : "opacity-0"}`}
                style={{ backgroundColor: glowColor }}
            />
            <div className="relative z-10 h-[350px] w-[350px] rounded-lg p-8 bg-[#1B182D] text-white">
                <div className="relative w-[58px] h-[58px]">
                    <div
                        className={`absolute inset-0 rounded-full transition-all duration-300 ${isHovered ? "bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] opacity-100" : "bg-white/10 blur-[2px]"}`}
                    />
                    <div className="absolute inset-[2px] rounded-full bg-[#1B182D] flex items-center justify-center">
                        <span className="text-white font-poppins-semibold text-xl">{number}</span>
                    </div>
                </div>
                <h1 className="mt-6 font-raleway_bold text-2xl">{title}</h1>
                <p className="mt-6 font-roboto text-base opacity-80">{text}</p>
            </div>
        </div>
    );

    return url ? (
        <a href={url} className="block no-underline text-inherit">
            <CardContent />
        </a>
    ) : (
        <CardContent />
    );
};

export default function Diferenciais({ servicosData, title }) {
    const { openModal } = useModal();
    return (
        <div className="w-full bg-[url(../assets/cover-proposito.png)] py-20 relative overflow-hidden text-white">
            <div className="max-w-[1200px] mx-auto relative z-10 px-4 md:px-8">
                <h2 className="font-inter-regular text-5xl md:text-[60px] text-center mb-12">
                    {title}
                </h2>
                <div className="relative mx-[-1rem] md:mx-[-2rem]">
                    <Carousel className="overflow-visible">
                        <div className="flex justify-end absolute right-8 md:right-16 top-6 z-10">
                            <CarouselPrevious className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
                            <CarouselNext className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
                        </div>
                        <CarouselContent className="py-8 px-6 md:px-8">
                            {servicosData.map((servico, index) => (
                                <CarouselItem
                                    key={index}
                                    className="basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/3 pl-4 md:pl-6"
                                >
                                    <div className="relative overflow-visible px-2">
                                        {servico.icon ? (
                                            <CardServicos 
                                                {...servico} 
                                                height={380}
                                            />
                                        ) : (
                                            <NumberedCard number={index + 1} {...servico} />
                                        )}
                                    </div>
                                </CarouselItem>
                            ))}
                        </CarouselContent>
                    </Carousel>
                    <div className="bg-[#2A0D5D] rounded-[30px] py-4 px-6 md:px-8 gap-6 md:gap-14 flex flex-col md:flex-row items-center w-fit mx-auto md:ml-16 mt-10 md:-mt-8">
                        <p className="text-xl font-inter-light text-center md:text-left">
                            Otimize seu <br /> negócio!
                        </p>
                        <button
                            type="button"
                            onClick={() => openModal(<FormularioRD />)}
                            className="cursor-pointer font-poppins-light bg-gradient-to-r from-[#A002CB] to-[#4B3BDB] flex items-center gap-2.5 rounded-full py-2 px-8 md:px-12 text-sm w-fit hover:scale-105 transition-transform duration-200"
                        >
                            Contratar
                            <ArrowUpRight width={20} />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
